import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './IconList.style'

const IconList = ({ data, t }) => {
  const { title, footerText, items } = data
  const styles = useStyles()
  return (
    <Box className={styles.root}>
      <Typography variant="h4" className={styles.iconListTitle}>
        {t(title)}
      </Typography>
      <Box className={styles.iconList}>
        {items.map((item, index) => (
          <Box className={styles.iconBox} key={index} variant="body1">
            <Box className={styles.SVGIcon}>{item.icon}</Box>
            <Typography>
              {t(item.text)} <b>{item.boldedText && t(item.boldedText)}</b>
            </Typography>
          </Box>
        ))}
        <Typography className={styles.footerText}>{t(footerText)}</Typography>
      </Box>
    </Box>
  )
}

export default IconList
